if (!customElements.get('how-to-measure-guide')) {
  customElements.define('how-to-measure-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.dialog = this.querySelector('.mg2-dialog');
      this.content = this.querySelector('[data-measure-content]');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (button?.hasAttribute('data-measure-close')) this.close();
        if (button?.dataset.measureType) {
          const next = button.dataset.measureType;
          if (next !== 'choice') this.lastType = next;
          this.render(next);
          const focusTarget = next === 'choice'
            ? this.content.querySelector('[data-measure-type="' + this.lastType + '"]')
            : this.content.querySelector('.mg2-back');
          focusTarget?.focus({ preventScroll: true });
        }
      }, options);
      this.dialog.addEventListener('pointerdown', event => {
        this.backdropDown = event.target === this.dialog && this.outside(event);
      }, options);
      this.dialog.addEventListener('click', event => {
        if (this.backdropDown && event.target === this.dialog && this.outside(event)) this.close();
        this.backdropDown = false;
      }, options);
      this.dialog.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const controls = [...this.dialog.querySelectorAll('button:not([disabled])')];
        const first = controls[0];
        const last = controls[controls.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }, options);
      this.dialog.addEventListener('close', () => {
        if (this.dialog.open) return;
        document.documentElement.classList.remove('cca-measure-open');
        if (this.lastLauncher?.isConnected) this.lastLauncher.focus({ preventScroll: true });
      }, options);
      this.addLauncher();
      this.observer = new MutationObserver(() => this.addLauncher());
      const owner = this.closest('product-info');
      if (owner) this.observer.observe(owner, { childList: true, subtree: true });
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      if (this.dialog?.open) this.close();
      document.documentElement.classList.remove('cca-measure-open');
      this.controller?.abort();
      this.launcher?.remove();
      this.ready = false;
    }
    outside(event) {
      const box = this.dialog.getBoundingClientRect();
      return event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom;
    }
    addLauncher() {
      if (this.dataset.autoLauncher === 'false' || this.launcher?.isConnected) return;
      const owner = this.closest('product-info');
      if (!owner) return;
      const label = [...owner.querySelectorAll('variant-selects fieldset legend, variant-radios fieldset legend, variant-selects label.form__label')].find(node => /size/i.test(node.textContent));
      if (!label) return;
      this.launcher = this.querySelector('[data-measure-launcher]').content.firstElementChild.cloneNode(true);
      this.launcher.dataset.guideSection = this.dataset.sectionId;
      this.launcher.setAttribute('aria-controls', this.dialog.id);
      this.launcher.addEventListener('click', () => this.open(this.launcher));
      label.classList.add('htm-guide__label-row');
      label.append(this.launcher);
    }
    render(state) {
      const template = this.querySelector('[data-measure-state="' + state + '"]');
      if (!template) return;
      this.content.replaceChildren(template.content.cloneNode(true));
      this.querySelector('.mg2-body').scrollTop = 0;
    }
    open(launcher) {
      if (this.dialog.open) return;
      this.lastLauncher = launcher;
      this.render(this.dataset.first);
      this.dialog.showModal();
      this.querySelector('.mg2-body').scrollTop = 0;
      document.documentElement.classList.add('cca-measure-open');
    }
    openFrom(launcher) { this.open(launcher); }
    close() { this.dialog.close(); }
  });
}
